import { render, staticRenderFns } from "./RepairOrder.vue?vue&type=template&id=b0cf8800&scoped=true&"
import script from "./RepairOrder.vue?vue&type=script&lang=js&"
export * from "./RepairOrder.vue?vue&type=script&lang=js&"
import style0 from "./RepairOrder.vue?vue&type=style&index=0&id=b0cf8800&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cf8800",
  null
  
)

export default component.exports